// Generated by purs version 0.13.8
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Data_Function = require("../Data.Function/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Lunarbox_Data_Dataflow_Scheme = require("../Lunarbox.Data.Dataflow.Scheme/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var typePipe = Lunarbox_Data_Dataflow_Scheme.Forall.create([ "i", "o" ])(Lunarbox_Data_Dataflow_Type.typeFunction(new Lunarbox_Data_Dataflow_Type.TVariable(true, "i"))(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeFunction(new Lunarbox_Data_Dataflow_Type.TVariable(true, "i"))(new Lunarbox_Data_Dataflow_Type.TVariable(true, "o")))(new Lunarbox_Data_Dataflow_Type.TVariable(true, "o"))));
var typeIdentity = Lunarbox_Data_Dataflow_Scheme.Forall.create([ "i" ])(Lunarbox_Data_Dataflow_Type.typeFunction(new Lunarbox_Data_Dataflow_Type.TVariable(true, "i"))(new Lunarbox_Data_Dataflow_Type.TVariable(true, "i")));
var typeFlip = (function () {
    var typeC = new Lunarbox_Data_Dataflow_Type.TVariable(true, "t2");
    var typeB = new Lunarbox_Data_Dataflow_Type.TVariable(true, "t1");
    var typeA = new Lunarbox_Data_Dataflow_Type.TVariable(true, "t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ "t0", "t1", "t2" ])(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeFunction(typeA)(Lunarbox_Data_Dataflow_Type.typeFunction(typeB)(typeC)))(Lunarbox_Data_Dataflow_Type.typeFunction(typeB)(Lunarbox_Data_Dataflow_Type.typeFunction(typeA)(typeC))));
})();
var typeConst = Lunarbox_Data_Dataflow_Scheme.Forall.create([ "input", "ignore" ])(Lunarbox_Data_Dataflow_Type.typeFunction(new Lunarbox_Data_Dataflow_Type.TVariable(true, "input"))(Lunarbox_Data_Dataflow_Type.typeFunction(new Lunarbox_Data_Dataflow_Type.TVariable(true, "ignore"))(new Lunarbox_Data_Dataflow_Type.TVariable(true, "input"))));
var typeCompose = (function () {
    var typeC = new Lunarbox_Data_Dataflow_Type.TVariable(true, "t2");
    var typeB = new Lunarbox_Data_Dataflow_Type.TVariable(true, "t1");
    var typeA = new Lunarbox_Data_Dataflow_Type.TVariable(true, "t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ "t0", "t1", "t2" ])(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeFunction(typeA)(typeB))(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeFunction(typeB)(typeC))(Lunarbox_Data_Dataflow_Type.typeFunction(typeA)(typeC))));
})();
var identity$prime = {
    name: "identity",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeIdentity)(new Lunarbox_Data_Dataflow_Runtime["Function"](Control_Category.identity(Control_Category.categoryFn))),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "x",
        description: "Any value"
    } ])({
        name: "x",
        description: "Returns it's input"
    })
};
var evalPipe = function (v) {
    return function (v1) {
        if (v1 instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
            return v1.value0(v);
        };
        return Lunarbox_Data_Dataflow_Runtime.Null.value;
    };
};
var pipe = {
    name: "pipe",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typePipe)(Lunarbox_Data_Dataflow_Runtime.binaryFunction(evalPipe)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "input",
        description: "The argument to pass to the given function"
    }, {
        name: "function",
        description: "A function to call with the given argument"
    } ])({
        name: "output",
        description: "Calls the first argument with the second."
    })
};
var evalFlip = function (v) {
    if (v instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
        return Lunarbox_Data_Dataflow_Runtime.binaryFunction(function (first) {
            return function (second) {
                var v1 = v.value0(second);
                if (v1 instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
                    return v1.value0(first);
                };
                return Lunarbox_Data_Dataflow_Runtime.Null.value;
            };
        });
    };
    return Lunarbox_Data_Dataflow_Runtime.Null.value;
};
var flip$prime = {
    name: "flip",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeFlip)(new Lunarbox_Data_Dataflow_Runtime["Function"](evalFlip)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "function",
        description: "A function which takes 2 arguments"
    } ])({
        name: "flipped function",
        description: "Returns a function which does the same things as the input function but with the arguments flipped around"
    })
};
var evalCompose = function (v) {
    return function (v1) {
        if (v instanceof Lunarbox_Data_Dataflow_Runtime["Function"] && v1 instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
            return Lunarbox_Data_Dataflow_Runtime["Function"].create(function ($17) {
                return v1.value0(v.value0($17));
            });
        };
        return Lunarbox_Data_Dataflow_Runtime.Null.value;
    };
};
var const$prime = {
    name: "const",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeConst)(Lunarbox_Data_Dataflow_Runtime.binaryFunction(Data_Function["const"])),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "constant value",
        description: "A value to always return"
    }, {
        name: "ignored value",
        description: "Any value"
    } ])({
        name: "constant value",
        description: "Returns the first argument."
    })
};
var compose = {
    name: "compose",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeCompose)(Lunarbox_Data_Dataflow_Runtime.binaryFunction(evalCompose)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "first function",
        description: "A function from type A to type B"
    }, {
        name: "second function",
        description: "A function from type B and type C"
    } ])({
        name: "second . first",
        description: "A function which first applies the A -> B transformation and then passes the return of that to the B -> C transformation returning a value of type C"
    })
};
var functionNodes = [ pipe, const$prime, identity$prime, compose, flip$prime ];
module.exports = {
    functionNodes: functionNodes
};
